import { Link, useNavigate } from "react-router-dom";
import { List, X } from "@phosphor-icons/react";
import { useState } from "react";
import { Logo } from "@/components/Logo";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { ThemeToggle } from "@/components/ThemeToggle";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const PublicNavbar = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const links = [
    { label: "Nasıl çalışır?", id: "nasil-calisir" },
    { label: "Sektörler", id: "sektorler" },
    { label: "Fiyatlandırma", id: "fiyatlandirma" },
    { label: "SSS", id: "sss" },
  ];

  const goSection = (id) => {
    setOpen(false);
    if (window.location.pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollTo(id), 300);
    } else {
      scrollTo(id);
    }
  };

  return (
    <header className="sticky top-0 z-50 bg-background/80 backdrop-blur-xl border-b border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo"><Logo /></Link>
        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <button key={l.id} onClick={() => goSection(l.id)}
              className="text-sm font-medium text-muted-foreground hover:text-brand transition-colors">
              {l.label}
            </button>
          ))}
          <Link to="/blog" className="text-sm font-medium text-muted-foreground hover:text-brand transition-colors">Blog</Link>
        </nav>
        <div className="hidden lg:flex items-center gap-3">
          <ThemeToggle />
          <LanguageSwitcher />
          <button onClick={() => navigate("/login")} data-testid="nav-login"
            className="text-sm font-medium text-foreground/85 hover:text-brand">Giriş Yap</button>
          <button onClick={() => navigate("/login")} data-testid="nav-start"
            className="bg-brand text-white text-sm font-medium px-4 py-2 hover:-translate-y-0.5 transition-transform">
            Ücretsiz Başla
          </button>
        </div>
        <button className="lg:hidden" onClick={() => setOpen((o) => !o)} data-testid="nav-mobile-toggle">
          {open ? <X size={24} /> : <List size={24} />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden border-t border-border bg-background px-4 py-4 space-y-3">
          {links.map((l) => (
            <button key={l.id} onClick={() => goSection(l.id)} className="block w-full text-left text-sm font-medium py-1.5">{l.label}</button>
          ))}
          <Link to="/blog" onClick={() => setOpen(false)} className="block text-sm font-medium py-1.5">Blog</Link>
          <button onClick={() => navigate("/login")} className="w-full bg-brand text-white text-sm font-medium px-4 py-2.5 mt-2">Ücretsiz Başla</button>
        </div>
      )}
    </header>
  );
};
